import {LogProps, translatedLogProps} from 'modules/logs/types';
import logsKeys from 'modules/logs/util/logs-keys';
import React from 'react';
import {useParams} from 'react-router-dom';
import Edition from 'shared/layout/edition';
import useFormInputs from 'shared/migration-components/form/util';

const EditLog: React.FC = () => {
  const {id} = useParams();
  const {getInput, getInlineCode} = useFormInputs<LogProps>();

  return (
    <Edition<LogProps>
      disabled={() => true}
      titleBar={{title: 'Editar log'}}
      inputs={[
        getInput({name: 'url'}),
        getInput({name: 'method'}),
        getInput({name: 'statusCode'}),
        getInput({name: 'duration'}),
        getInput({name: 'createdAt'}),
        getInlineCode({name: 'request'}),
        getInlineCode({name: 'response'}),
        getInlineCode({name: 'headers'}),
      ]}
      detailsUrl={`/logs/${id}`}
      translationKey={translatedLogProps}
      queryKey={logsKeys.details(id!)}
    />
  );
};

export default EditLog;
